import { createAsyncThunk } from "@reduxjs/toolkit";
import * as chatService from "../../services/chatService";
import { enqueueSnackbar } from "notistack";
import * as API from "../../services/Api";

export const getChatList = createAsyncThunk(
  "chat/getChatList",
  async (params, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      // Now pass the object directly
      const response = await chatService.getChatList(params);
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const joinChat = createAsyncThunk(
  "chat/joinChat",
  async (chatData, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await chatService.joinChat(chatData);
      enqueueSnackbar(response.message || "Successfully joined chat room", {
        variant: "success",
      });

      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const getChatMessages = createAsyncThunk(
  "chat/getChatMessages",
  async ({ chatId, page, limit }, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token =
        state.auth?.user?.authentication?.accessToken ||
        localStorage.getItem("token");

      if (token) {
        API.setHeaderAuthorization(token);
      }

      const response = await chatService.getChatMessages(chatId, page, limit);
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);
